import React from 'react'
import qs from 'query-string'

import { useStateContext } from '@zambezi/caballo-vivo'

import { STAFF_PORTAL_HOST } from '../../staff'

export default function CustomerNotFound() {
  const state = useStateContext()
  const authToken = state.get('authToken')
  const staffPortalSearchQuery = state.get('staffPortalSearchQuery')
  const customerCin = qs.parse(staffPortalSearchQuery).cin || ''
  return (
    <section className="ob-error">
      <h1 className="zb-heading2">Customer Not Found</h1>

      <div className="zb-card">
        <div className="zb-card-body">
          Your search for customer {customerCin ? `'${customerCin}'` : ''}{' '}
          returned no matching results
        </div>
      </div>
      <p>
        <a
          href={`${STAFF_PORTAL_HOST}/internal-consent#access_token=${authToken}`}
          className="zb-button zb-button-primary"
        >
          Back to customer search
        </a>
      </p>
    </section>
  )
}
